export let tips_FlexPane_Title = "vsVuW";
export default {tips_FlexPane_Title};